import { Injectable, Inject, Optional } from '@angular/core';

import { HttpRequest } from '@relevance/core';
import { ProcessingService } from '@relevance/angular-core';

import { ILocationCoords, ILocationInfo } from './geo.model';

/**
 * This service is used for geolocalization.
 */
@Injectable()
export class GeolocationService {

  private lastError: number = 1;

  constructor(
    private processingService: ProcessingService,
  ) { }

  /**
   * Check if the permission for location has been granted.
   */
  public hasPermission(): boolean {
    return this.lastError !== 1;
  }

  /**
   * Get the current coordinates.
   */
  public getCurrentCoordinates(): Promise<ILocationCoords> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (data) => {
          this.lastError = 0;
          resolve({ lat: data.coords.latitude, long: data.coords.longitude });
        },
        (err) => {
          if (err.code) {
            this.lastError = err.code;
          }
          reject(err);
        },
      );
    });
  }

  /**
   * Get current location information.
   */
  public getCurrentLocation(distance?: number): Promise<ILocationInfo> {
    return new Promise((resolve, reject) => {
      return this.getLocationsNearMe(distance)
        .then((items) => resolve(items[0]))
        .catch(reject);
    });
  }

  /**
   * Perform a reverse geocoding location match.
   */
  public getLocationsNear(
    lat: number,
    long: number,
    distance?: number,
    max_count?: number,
  ): HttpRequest<ILocationInfo[]> {
    const args: any = {};
    if (distance) {
      args.distance = distance;
    }
    if (max_count) {
      args.max_count = max_count;
    }

    return this.processingService.runAlgo<ILocationInfo[]>(
      'relevance_simplemaps.algos.ReverseGeocodingTagger',
      'http://192.168.11.101:9200/worldcities',
      [lat, long],
      args,
    );
  }

  public getLocationsNearMe(distance?: number, max_count?: number): Promise<ILocationInfo[]> {
    return new Promise((resolve, reject) => {
      this.getCurrentCoordinates()
        .then((coords) => {
          this.getLocationsNear(coords.lat, coords.long, distance, max_count)
            .then((items) => resolve(items))
            .catch(reject);
        }, reject);
    });
  }

  /**
   * Perform a geocoding location match.
   */
  public getLocationsLike(name: string): HttpRequest<ILocationInfo[]> {
    return this.processingService.runAlgo<ILocationInfo[]>(
      'relevance_simplemaps.algos.GeocodingTragger',
      'http://192.168.11.101:9200/worldcities',
      name,
    );
  }

}
